import { conjoinItems } from "./conjoin-items";
export var sliceConnectedFieldsText = function (slice) {
  var _a = slice.connectedEntities,
    connectedEntities = _a === void 0 ? [] : _a;
  var text = 'items';
  if (connectedEntities.length !== 0) {
    text = conjoinItems(connectedEntities.map(function (field) {
      return field.label || field.name;
    }));
  }
  return text;
};